import React from "react";
import styled, { css } from "styled-components";
import { Spacing } from "@glossy";

type IProps = React.FieldsetHTMLAttributes<HTMLFieldSetElement>

const StyledFieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  row-gap: ${Spacing.ExtraSmall};
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;

const UiKitFormFieldset = (props: IProps) => <StyledFieldset {...props} />;

export default UiKitFormFieldset;
